import type { AccessDecision } from "../auth/config"
import { getModeratedTextErrorCode } from "../moderation/text"
import type { GamerTagRegistryState, PlayerProfileStoreState } from "./storage"

export type GamerTagErrorCode = "length" | "characters" | "blocked" | "taken"
export type DisplayNameErrorCode = "length" | "blocked"

export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase()
}

export function normalizeGamerTag(gamerTag: string): string {
  return gamerTag.trim().toLowerCase()
}

export function createProfileId(email: string): string {
  return `player_${normalizeEmail(email).replace(/[^a-z0-9]+/g, "_")}`
}

export function getRoleForAccess(access: AccessDecision): "player" | "admin" {
  return access === "bootstrap_admin" ? "admin" : "player"
}

export function getInviteStatusForAccess(
  access: AccessDecision,
): "invited" | "bootstrap_admin" {
  return access === "bootstrap_admin" ? "bootstrap_admin" : "invited"
}

export function validateGamerTag(
  gamerTag: string,
  registry: GamerTagRegistryState,
  ownerEmail?: string,
): GamerTagErrorCode | null {
  const trimmed = gamerTag.trim()

  if (trimmed.length < 3 || trimmed.length > 20) {
    return "length"
  }

  if (!/^[A-Za-z0-9_-]+$/.test(trimmed)) {
    return "characters"
  }

  if (getModeratedTextErrorCode(trimmed)) return "blocked"

  const normalized = normalizeGamerTag(trimmed)
  const existingOwner = registry[normalized]

  if (existingOwner && existingOwner !== ownerEmail) {
    return "taken"
  }

  return null
}

export function validateDisplayName(
  displayName: string,
): DisplayNameErrorCode | null {
  const trimmed = displayName.trim()

  if (trimmed.length < 1 || trimmed.length > 30) {
    return "length"
  }

  if (getModeratedTextErrorCode(trimmed)) return "blocked"

  return null
}

export function getProfileByEmail(
  profiles: PlayerProfileStoreState,
  email: string,
) {
  return profiles[normalizeEmail(email)] ?? null
}
